import React, { Fragment, useCallback } from 'react';
import { browserHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { hideModal } from 'cards/actions/modalActions';
import { setPendingChanges } from 'cards/reducers/customization/actions';

type LeaveGuestNoteModalProps = {
  confirmButtonText: string;
  proceedLocation?: string;
  callback?: () => void;
};

const LeaveGuestNoteModal = ({
  confirmButtonText = 'Continue',
  proceedLocation,
  callback,
}: LeaveGuestNoteModalProps): JSX.Element => {
  const dispatch = useDispatch();
  const onConfirm = useCallback(() => {
    dispatch(hideModal());
    dispatch(setPendingChanges(false));
    if (proceedLocation) browserHistory.push(proceedLocation);
    if (typeof callback === 'function') callback();
  }, [dispatch, proceedLocation, callback]);
  const onCancel = useCallback(() => dispatch(hideModal()), [dispatch]);

  return (
    <Fragment>
      <div className="modal-header">
        <h2 className="modal-title">Are you sure you want to leave?</h2>
      </div>
      <div className="modal-body">
        <p className="text-left">By leaving, the progress on your current message will be lost.</p>
      </div>
      <div className="modal-footer">
        <div className="text-group row">
          <ButtonV2 onClick={onConfirm} variant="secondary" className="btn-left">
            {confirmButtonText}
          </ButtonV2>
          <ButtonV2 onClick={onCancel} className="btn-right">
            Back To My Note
          </ButtonV2>
        </div>
      </div>
    </Fragment>
  );
};

export default LeaveGuestNoteModal;
